import { loan_request } from '@axo/shared/data-access/types';

export type ApplicantModeOption = {
  label: string;
  value: loan_request.ApplicantMode;
};

export const applicationModeOptions: ApplicantModeOption[] = [
  {
    label: 'Default',
    value: loan_request.ApplicantMode.ApplicantModeNormal,
  },
  {
    label: 'Main Applicant only',
    value: loan_request.ApplicantMode.ApplicantModeMainApplicant,
  },
  {
    label: 'Co-Applicant Only',
    value: loan_request.ApplicantMode.ApplicantModeCoApplicant,
  },
  {
    label: 'Swap Applicants',
    value: loan_request.ApplicantMode.ApplicantModeSwap,
  },
];
